import { useEffect, type ReactNode } from 'react';

const STORAGE_KEY = 'pm-theme';

export function ThemeProvider({ children }: { children: ReactNode }) {
  // Always apply light theme
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add('light');
    try {
      localStorage.setItem(STORAGE_KEY, 'light');
      localStorage.removeItem('hr-theme');
    } catch {
      // Theme initialization must still work when browser storage is restricted.
    }
  }, []);

  return <>{children}</>;
}
